import React, { useLayoutEffect, useRef } from "react";
import PropTypes from "prop-types";

const COMPACT_HEIGHT = 48;
const FOCUSED_HEIGHT = 96;

export default function AutoGrowingNoteTextarea({
  value,
  onChange,
  onFocus,
  onBlur,
  style,
  id,
  name,
  placeholder,
  "aria-label": ariaLabel,
}) {
  const textareaRef = useRef(null);

  const resizeToContent = (textarea, expanded = false) => {
    if (!textarea) return;
    textarea.style.height = "auto";
    const minimumHeight = expanded ? FOCUSED_HEIGHT : COMPACT_HEIGHT;
    textarea.style.height = `${Math.max(minimumHeight, textarea.scrollHeight)}px`;
  };

  useLayoutEffect(() => {
    const textarea = textareaRef.current;
    resizeToContent(textarea, document.activeElement === textarea);
  }, [value]);

  return (
    <textarea
      ref={textareaRef}
      id={id}
      name={name}
      aria-label={ariaLabel}
      placeholder={placeholder}
      rows={1}
      value={value}
      onChange={(event) => {
        resizeToContent(event.currentTarget, true);
        onChange(event);
      }}
      onFocus={(event) => {
        resizeToContent(event.currentTarget, true);
        onFocus?.(event);
      }}
      onBlur={(event) => {
        resizeToContent(event.currentTarget, event.currentTarget.value !== "");
        onBlur?.(event);
      }}
      style={{
        ...style,
        minHeight: COMPACT_HEIGHT,
        overflow: "hidden",
        resize: "none",
        textAlign: "left",
      }}
    />
  );
}

AutoGrowingNoteTextarea.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  style: PropTypes.object,
  id: PropTypes.string,
  name: PropTypes.string,
  placeholder: PropTypes.string,
  "aria-label": PropTypes.string.isRequired,
};
